export default __webpack_public_path__ + "static/media/notifications_2.f8ce703d.png";